import React from 'react';

export default function TermsConditions() {
  return (
    <div className="py-20 bg-white min-h-[60vh]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-gray">
        <h1 className="text-3xl font-serif mb-6 text-gray-900">Terms & Conditions</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: [Current Date]</p>
        
        <p className="mb-4">Welcome to Tatvam. These terms and conditions outline the rules and regulations for the use of Tatvam's Website, located at tatvamretail.in.</p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">1. Terms</h2>
        <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use Tatvam if you do not agree to take all of the terms and conditions stated on this page.</p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">2. Service & Pricing</h2>
        <p>Prices for our products and tailoring services are subject to change without notice. We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time.</p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">3. Accuracy of Information</h2>
        <p>We are not responsible if information made available on this site is not accurate, complete or current. The material on this site is provided for general information only.</p>
      </div>
    </div>
  );
}